import { NAV_SECTIONS } from "@/features/docs/components/DocsSidebar";
import { docsActiveSectionAtom } from "@/features/docs/docsNavStore";
import { cn } from "@/utils/cn";
import { closeLeftSidebarAtom } from "@/utils/sidebarStore";
import { useAtomValue, useSetAtom } from "jotai";

/**
 * The Docs table of contents, rendered inside the persistent left rail (where
 * chat Sessions live on other routes). Self-contained: it drives in-page
 * navigation by scrolling to section ids and reads the active section from a
 * shared atom the DocsPage scroll-spy writes to.
 */
export const DocsSidebarSection = () => {
  const activeSection = useAtomValue(docsActiveSectionAtom);
  const setActiveSection = useSetAtom(docsActiveSectionAtom);
  const closeLeftSidebar = useSetAtom(closeLeftSidebarAtom);

  const handleNavigate = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "instant", block: "start" });
    setActiveSection(id);
    closeLeftSidebar();
  };

  return (
    <nav aria-label="Documentation" className="pb-5 pt-1">
      {NAV_SECTIONS.map((section) => (
        <div key={section.title} className="mb-5">
          <div className="font-ui px-5 pb-1 text-zinc-300">
            {section.title}
          </div>
          <ul>
            {section.items.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => handleNavigate(item.id)}
                  aria-current={activeSection === item.id ? "true" : undefined}
                  className={cn(
                    "w-full px-5 py-1 text-left text-xs leading-5 transition-colors",
                    // Command names stay lowercase mono; prose labels take the caps register.
                    /^[a-z][a-z0-9 /-]*$/.test(item.label) ? "font-mono" : "font-ui",
                    activeSection === item.id
                      ? "text-zinc-900"
                      : "text-zinc-400 hover:text-zinc-800",
                  )}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};
